import { Intervention, PathwayIntervention } from '@/types';

const helpFor = (i: Intervention | PathwayIntervention) => {
  if (i.type == 'grid-decarbonisation') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_59db615982';
  } else if (i.type === 'grid-decarbonisation-percentage') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_59db615982';
  } else if (i.type === 'building-efficiency') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_25e165d5e7';
  } else if (i.type === 'building-electrification') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_01284fd010';
  } else if (i.type === 'new-building-standards') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_93af500ebe';
  } else if (i.type === 'mode-shift-to-public-transport') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_a8d4bcd878';
  } else if (i.type === 'mode-shift-to-active-transport') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_a8d4bcd878';
  } else if (i.type === 'electric-vehicle-takeup') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_dec8ae3095';
  } else if (i.type === 'road-to-rail-freight-mode-shift') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas';
  } else if (i.type === 'rail-freight-efficiency') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_ccd1bd2129';
  } else if (i.type === 'air-transport-efficiency') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_0918a696b9';
  } else if (i.type === 'waste-reduction') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_177ee84a1b';
  } else if (i.type === 'waste-diversion-from-landfill') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_8500812ff0';
  } else if (i.type === 'waste-treatment') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_e40a5c6ae1';
  } else if (i.type === 'wastewater-treatment') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_0b8020419a';
  } else if (i.type === 'industrial-processes') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_52d9f79bb4';
  } else if (i.type === 'product-use') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_c279459baf';
  } else if (i.type === 'livestock') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_ed8bbeb1bc';
  } else if (i.type === 'horticulture') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_a7da0871fa';
  } else if (i.type === 'exotic-forest-change') {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas#h_1e5fe5c142';
  } else {
    return 'https://help.kinesis.org/en/articles/11586392-intervention-areas';
  }
};

export { helpFor };
